import React, {useState} from "react";
import ForecastPreview from './ForecastPreview';

import './Forecast.css';
import axios from "axios";

export default function Forecast(props){
    const [loaded, setLoaded]=useState(false);
    const [forecast, setForecast]=useState(null);
    function handleForecastResponse(response) { 
        setForecast(response.data);        
        setLoaded(true);

}
if(loaded && props.city===forecast.city.name){return(

<div className="forecast row" >
    
    <ForecastPreview data={forecast.list[0]}/> 
    <ForecastPreview data={forecast.list[1]}/> 
    <ForecastPreview data={forecast.list[2]}/> 
    <ForecastPreview data={forecast.list[3]}/> 
    <ForecastPreview data={forecast.list[4]}/> 

    </div>);} 
else {    
const apiKey = "5b0bfa960cf8480fafd9ea6aed867930";
    let apiUrl = `https://api.openweathermap.org/data/2.5/forecast?q=${props.city}&appid=${apiKey}&units=metric`;
    axios.get(apiUrl).then(handleForecastResponse);}
   return ("loading...");

    }
    




